import script from "./userApiManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./userApiManagement.vue?vue&type=script&setup=true&lang=js"

import "./userApiManagement.vue?vue&type=style&index=0&id=4e20a04a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e20a04a"]])

export default __exports__